import { useEffect } from 'react';

const useAutoUpdate = (checkIntervalMs = 60000) => { // Cek tiap 60 detik
    useEffect(() => {
        const checkVersion = async () => {
            try {
                // Fetch versi dengan query string timestamp agar tidak terkena cache
                const response = await fetch(`/version.json?t=${Date.now()}`, {
                    cache: 'no-store',
                });

                if (!response.ok) return;

                const data = await response.json();

                // Gabungkan version dan build sebagai identifier unik (Contoh: "1.1.2_2026.09.14-05.00")
                const currentServerAppId = `${data.version}_${data.build}`;
                const storedAppId = localStorage.getItem('app_build_id');

                if (!storedAppId) {
                    // Pertama kali user buka web, simpan ID build-nya
                    localStorage.setItem('app_build_id', currentServerAppId);
                } else if (storedAppId !== currentServerAppId) {
                    // Terdeteksi ada build baru (entah versi atau timestamp build-nya berubah)
                    localStorage.setItem('app_build_id', currentServerAppId);

                    // Force reload halaman browser dari server
                    window.location.reload(true);
                }
            } catch (error) {
                console.error('Gagal mengecek update aplikasi:', error);
            }
        };

        // Jalankan saat komponen dimuat
        checkVersion();

        // Jalankan timer berkala
        const interval = setInterval(checkVersion, checkIntervalMs);

        return () => clearInterval(interval);
    }, [checkIntervalMs]);
};

export default useAutoUpdate;